export const CONDITION = "condition"
export const QUESTIONNAIRE = "questionnaire"
export const TEXT = "text"
export const PAUSE = "pause"